try {
  if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');else require('./index.css');
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e; // Re-throw unexpected errors
  }

  console.warn('index.css / index-new.css not found, proceeding without it.');
}
import { jsxs, jsx } from 'react/jsx-runtime';
import { ErrorMessage } from '@design-system/error-message';
import { FieldHead } from '@design-system/field-head';
import classNames from 'classnames';
import { forwardRef } from 'react';
var LongTextField = forwardRef(function (_ref, ref) {
  var className = _ref.className,
    id = _ref.id,
    rows = _ref.rows,
    cols = _ref.cols,
    name = _ref.name,
    label = _ref.label,
    textareaId = _ref.textareaId,
    description = _ref.description,
    tooltipText = _ref.tooltipText,
    tooltipLabel = _ref.tooltipLabel,
    placeholder = _ref.placeholder,
    errorMessage = _ref.errorMessage,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur;
  return jsxs("div", Object.assign({
    ref: ref,
    className: classNames('cds-long-text-field', className)
  }, {
    children: [jsx(FieldHead, {
      id: id,
      label: label,
      description: description,
      tooltipText: tooltipText,
      tooltipLabel: tooltipLabel
    }), jsx("textarea", {
      className: classNames('cds-long-text-field__textarea', {
        'cds-long-text-field__textarea--error': Boolean(errorMessage)
      }),
      cols: cols,
      rows: rows,
      name: name,
      placeholder: placeholder,
      onChange: onChange,
      onBlur: onBlur,
      "aria-invalid": Boolean(errorMessage),
      id: textareaId
    }), jsx(ErrorMessage, {
      message: errorMessage
    })]
  }));
});
export { LongTextField };